import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { TAG_NAME_MAX_LENGTH } from '../../common/constants';

export const templateTagsNetworkFilter = document.createElement('template');

templateTagsNetworkFilter.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class="wrapper">
    <gz-tags-enum-filter searchMaxLength="${TAG_NAME_MAX_LENGTH}" id="tag-filter-for-pe" allowSelectNone canSelectAll labelWidth="full" class="w-full" autoAdjustMenuPosition></gz-tags-enum-filter>
  </div>
`;
